"use client";

import { Badge } from "@universe/ui/components/badge";
import { cn } from "@universe/ui/lib/utils";
import { useTranslations } from "next-intl";

import UPLogo from "./up-logo";

interface PoweredByUMProps {
  /** Use "dark" on light backgrounds (registration, onboarding cards) */
  variant?: "light" | "dark";
}

/**
 * Shown in sidebar footer (light variant) and on registration welcome
 * page (dark variant) when whitelabel is active.
 */
export const PoweredByUM = ({ variant = "light" }: PoweredByUMProps) => {
  const t = useTranslations("common");

  return (
    <div className="flex flex-col items-center justify-center relative fade-in duration-300">
      <Badge
        variant="secondary"
        className={cn(
          "text-xs",
          variant === "dark"
            ? "bg-brand-primary/10 text-brand-strong border-brand-primary/30 hover:bg-brand-primary/20"
            : "bg-white/20 text-white border-white/30 hover:bg-white/25"
        )}
      >
        {t("poweredBy")}
      </Badge>
      <UPLogo
        width={95}
        height={95}
        className="py-0"
        variant={variant === "dark" ? "blue" : "white"}
      />
    </div>
  );
};

export default PoweredByUM;
